<template lang="pug">
.container.grid-xl.py-2.manual-page
  .columns
    .column.col-12
      router-link.btn.btn-link.btn-sm(:to="{ name: 'app.manuais' }")
        i.fa.fa-arrow-left.fa-fw
        |  Voltar aos manuais

      h4.h4 Mensagens — Nova mensagem
      p.text-gray Manual do usuário · OS-m Admin v1.84+

      h5.h5 Visão geral
      p
        | Esta parte explica como
        strong  enviar uma mensagem
        |  para um destinatário a partir da
        strong  Caixa de mensagens
        | .

      .toast.toast-primary
        | A caixa fica no menu
        strong  Mensagens
        | , para o usuário autenticado.

      h5.h5 1. Abrir o formulário
      ol
        li No menu lateral, clique em
          strong  Mensagens
          | .
        li Na caixa, clique em
          strong  Nova mensagem
          | . Abre o modal com o mesmo título.

      h5.h5 2. Preencher e enviar
      figure.manual-figure
        img(:src="imgForm" alt="Modal de nova mensagem")
      ol
        li Em
          strong  Destinatário
          | , pesquise e selecione a pessoa. O campo é obrigatório.
        li Em
          strong  Prioridade
          | , escolha
          strong  Baixa
          | ,
          strong  Média
          | ,
          strong  Alta
          |  ou
          strong  Máxima
          | . O padrão é
          strong  Média
          | .
        li Informe
          strong  Título
          |  e
          strong  Conteúdo
          | . O conteúdo precisa ter pelo menos 10 caracteres.
        li Clique em
          strong  Enviar
          | . A confirmação é
          strong  Mensagem enviada
          |  e o modal fecha.
        li O X fecha o modal sem enviar e limpa os campos.
      p A mensagem enviada passa a aparecer em
        strong  Mensagens enviadas
        | .

      .divider
      router-link.btn.btn-primary(:to="{ name: 'app.manuais' }")
        i.fa.fa-book.fa-fw
        |  Voltar à lista de manuais
</template>

<script>
export default {
  data() {
    return {
      imgForm: require("@/assets/manuais/48-mensagens-nova.png"),
    }
  },
}
</script>

<style lang="stylus" scoped>
.manual-page
  h5
    margin-top 1.5rem

  .manual-figure
    margin 1rem 0
    img
      max-width 100%
      height auto
      border 1px solid #e7e9ed
      border-radius 4px

  .toast
    margin 1rem 0
</style>
